/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */

import React, { FunctionComponent, useEffect } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { AppRoute } from "../../utils/routes/routes.util";
import { useAuthProvider } from "../auth-provider-loader/auth-provider-loader.component";
import { AuthenticationRequiredRouteProps } from "./authentication-required-route.interfaces";

export const AuthenticationRequiredRoute: FunctionComponent<AuthenticationRequiredRouteProps> =
    ({ children, ...rest }) => {
        const history = useHistory();
        const location = useLocation();
        const { isAuthenticated } = useAuthProvider();

        useEffect(() => {
            if (!isAuthenticated) {
                history.push(AppRoute.LOGIN, { from: location });
            }
        }, []);

        return <Route {...rest} render={() => children} />;
    };
